'use strict';
define([], function () {
    function Controller($scope, $state, userInfo, SEOProjectsService, AuthService, TrackEventService, $localStorage, FavIconService, SearchConsoleService, $window, $translate, $interval, $timeout, $mdDialog) {
        var vm = $scope;
        var reportGeneration = 0;
        var destroyed = false;
        var AI_MENTIONS_TARGET = 1248;
        var lastCheckedSearchConsoleConnection;
        var searchConsoleGeneration = 0;
        TrackEventService.gaV2Event('screen_view', {screen_name: 'dashboard'});
        vm.currentUser = userInfo;
        vm.workspace = $localStorage.currentUser && $localStorage.currentUser.workspace || {};
        vm.projects = [];
        vm.projectRows = [];
        vm.isLoading = true;
        vm.projectLoadError = false;
        vm.searchConsoleChecking = false;
        vm.searchConsoleMissingCount = 0;
        vm.connectSearchConsole = connectSearchConsole;
        vm.openProjectStat = openProjectStat;
        vm.deleteProject = deleteProject;
        vm.dashboardView = {filter: 'all', search: ''};

        function openProjectStat(row, section) {
            if (!row || !row.id) return;
            if (section === 'tracker') {
                $state.go('app.project.detail.tracker', {projectId: row.id});
                return;
            }
            if (section === 'searchConsole') {
                $state.go('app.project.detail.searchConsole', {projectId: row.id, view: 'query'});
            }
        }
        /* Empty state: the preview tells one story in four scenes: find issues,
           fix them, improve rankings, then inspect the SEO data. */
        vm.emptyScene = 'issues';
        vm.emptySceneList = [
            {id: 'issues', icon: 'ti-alert-triangle', key: 'dashboard.overview.previewIssues.title'},
            {id: 'fix', icon: 'ti-tool', key: 'dashboard.overview.previewFix.title'},
            {id: 'tracker', icon: 'ti-chart-line', key: 'dashboard.overview.previewRank.title'},
            {id: 'traffic', icon: 'ti-chart-histogram', key: 'dashboard.overview.previewData.title'}
        ];
        vm.scanPages = 0;
        vm.scanProgress = 0;
        vm.reportScore = 0;
        vm.reportIssues = 0;
        vm.reportPassed = 0;
        vm.trackerAvgPosition = 12;
        vm.trackerProgress = 0;
        vm.trackerEndVisible = false;
        vm.youMarker = {left: 6, top: 75};
        vm.compMarkers = [{left: 6, top: 20}, {left: 6, top: 40}];
        /* Valori del rullo della posizione media: 12 → 1 a passi di mezzo punto. */
        vm.trackerPositionValues = [];
        for (var positionValue = 12; positionValue >= 1; positionValue -= 0.5) {
            vm.trackerPositionValues.push(positionValue % 1 === 0 ? String(positionValue) : positionValue.toFixed(1));
        }
        vm.trackerAvgIndex = 0;
        vm.trackerGained = 0;
        vm.aiMentions = 0;
        vm.agentReadyScore = 0;
        vm.agentReadyStatus = 'Checking AI visibility';
        vm.previewCompetitors = [
            {name: 'Samsung', domain: 'samsung.com', color: '#2f90de', cls: 'samsung',
                pts: [[6, 8], [14, 9], [22, 8], [30, 9], [38, 8], [46, 10], [54, 9], [62, 8], [70, 10], [78, 9], [86, 8], [94, 8]]},
            {name: 'Microsoft', domain: 'microsoft.com', color: '#8e44ad', cls: 'microsoft',
                pts: [[6, 16], [14, 15], [22, 14], [30, 13], [38, 12], [46, 13], [54, 12], [62, 11], [70, 13], [78, 12], [86, 11], [94, 11]]}
        ];
        /* Traiettoria realistica: piccole oscillazioni quando è indietro, guadagni
           più netti a metà, assestamenti e lievi cali vicino alla vetta. */
        vm.previewYou = {
            name: 'Your Website', color: 'var(--sto-color-primary)',
            pts: [
                /* Traiettoria traslata in su di 15px; il secondo pallino è stato
                   abbassato di 20px rispetto al punto precedente. */
                [3, 26.3], [7.5, 27.4], [12, 25.3], [16.5, 26.7], [21, 20.3], [25.5, 24.6],
                [30, 23.1], [34.5, 24.1], [39, 21.3], [43.5, 22.2], [48, 18.7], [52.5, 19.4],
                [57, 16.5], [61.5, 13.4], [66, 14.2], [70.5, 11.3], [75, 8.5], [79.5, 9.4],
                [84, 6.4], [88.5, 4.3], [93, 2.8], [97, 1.4]
            ]
        };
        /* Un pallino sì e uno no: la curva ha molti punti, i marker restano leggibili. */
        vm.previewRankDots = vm.previewYou.pts.filter(function (_, i) { return i % 2 === 0; })
            .map(function (pt) { return {x: pt[0], y: pt[1]}; });
        vm.previewFavicon = function (domain) {
            return 'https://www.google.com/s2/favicons?sz=64&domain=' + domain;
        };
        /* Catmull-Rom convertito in Bézier: una curva liscia che passa per i punti. */
        vm.previewSmoothPath = function (pairs) {
            var points = pairs.map(function (pair) { return {x: pair[0], y: pair[1]}; });
            if (points.length < 2) return '';
            var d = 'M' + points[0].x + ' ' + points[0].y;
            for (var i = 0; i < points.length - 1; i++) {
                var p0 = points[i - 1] || points[i];
                var p1 = points[i];
                var p2 = points[i + 1];
                var p3 = points[i + 2] || p2;
                var c1x = p1.x + (p2.x - p0.x) / 6;
                var c1y = p1.y + (p2.y - p0.y) / 6;
                var c2x = p2.x - (p3.x - p1.x) / 6;
                var c2y = p2.y - (p3.y - p1.y) / 6;
                d += ' C' + c1x + ' ' + c1y + ' ' + c2x + ' ' + c2y + ' ' + p2.x + ' ' + p2.y;
            }
            return d;
        };
        /* Stesso Catmull-Rom del path SVG, ma campionato punto per punto:
           serve per far viaggiare i marker esattamente sulla curva. */
        vm.previewCurvePoint = function (pairs, t) {
            var pts = pairs.map(function (pair) { return {x: pair[0], y: pair[1]}; });
            var n = pts.length;
            var seg = Math.min(Math.floor(t), n - 2);
            var f = Math.min(Math.max(t - seg, 0), 1);
            var p0 = pts[Math.max(seg - 1, 0)];
            var p1 = pts[seg];
            var p2 = pts[Math.min(seg + 1, n - 1)];
            var p3 = pts[Math.min(seg + 2, n - 1)];
            var f2 = f * f;
            var f3 = f2 * f;
            return {
                x: 0.5 * (2 * p1.x + (-p0.x + p2.x) * f + (2 * p0.x - 5 * p1.x + 4 * p2.x - p3.x) * f2 + (-p0.x + 3 * p1.x - 3 * p2.x + p3.x) * f3),
                y: 0.5 * (2 * p1.y + (-p0.y + p2.y) * f + (2 * p0.y - 5 * p1.y + 4 * p2.y - p3.y) * f2 + (-p0.y + 3 * p1.y - 3 * p2.y + p3.y) * f3)
            };
        };
        vm.previewAnomalies = [
            {label: 'Title mancanti', state: '', fill: 34},
            {label: 'Errori 404', state: '', fill: 22},
            {label: 'Elementi duplicati', state: '', fill: 28},
            {label: 'Problemi di indicizzazione', state: '', fill: 41},
            {label: 'Immagini senza alt', state: '', fill: 17},
            {label: 'Hreflang', state: '', fill: 51}
        ];

        var sceneOrder = ['issues', 'fix', 'tracker', 'traffic'];
        var sceneTimers = [];
        var scanTimers = [];

        function cancelTimers(list) {
            list.forEach(function (timer) { if (timer && timer.cancel) timer.cancel(); });
            list.length = 0;
        }

        function stopEmptyStory() {
            cancelTimers(sceneTimers);
            cancelTimers(scanTimers);
            vm.scanPages = 0;
            vm.scanProgress = 0;
            vm.reportScore = 0;
            vm.reportIssues = 0;
            vm.reportPassed = 0;
            vm.trackerAvgPosition = 12;
            vm.trackerProgress = 0;
            vm.trackerEndVisible = false;
            vm.trackerAvgIndex = 0;
            vm.trackerGained = 0;
            vm.aiMentions = 0;
            vm.agentReadyScore = 0;
            vm.agentReadyStatus = 'Checking AI visibility';
            vm.previewAnomalies.forEach(function (item) { item.state = ''; });
        }

        /* The pages counter runs while the scan scene is on stage. */
        function runScanCounter() {
            vm.scanPages = 0;
            vm.scanProgress = 0;
            var counter = $interval(function () {
                vm.scanPages = Math.min(vm.scanPages + 2, 78);
                vm.scanProgress = Math.round(vm.scanPages / 78 * 100);
                if (vm.scanPages >= 78) $interval.cancel(counter);
            }, 40);
            scanTimers.push(counter);
        }

        /* First story: problems are found one by one. */
        function runScanStory() {
            runScanCounter();
            vm.agentReadyScore = 0;
            vm.agentReadyStatus = 'Checking AI visibility';
            var readinessCounter = $interval(function () {
                vm.agentReadyScore = Math.min(vm.agentReadyScore + 3, 84);
                if (vm.agentReadyScore >= 70) vm.agentReadyStatus = 'Agent Ready';
                if (vm.agentReadyScore >= 84) $interval.cancel(readinessCounter);
            }, 55);
            scanTimers.push(readinessCounter);
            vm.previewAnomalies.forEach(function (item, index) {
                scanTimers.push($timeout(function () { item.state = 'is-found'; }, 800 + index * 450));
            });
        }

        /* La linea arancione risale con alti e bassi: i marker viaggiano sulla
           curva reale e il disegno parte piano, accelera a metà e rallenta in cima. */
        function runTrackerStory() {
            vm.trackerAvgPosition = 12;
            vm.trackerAvgIndex = 0;
            vm.trackerGained = 0;
            vm.aiMentions = 0;
            vm.trackerProgress = 0;
            vm.trackerEndVisible = false;
            var youPts = vm.previewYou.pts;
            var compPts = [vm.previewCompetitors[0].pts, vm.previewCompetitors[1].pts];
            var youStart = vm.previewCurvePoint(youPts, 0);
            vm.youMarker = {left: youStart.x, top: youStart.y * 2.5};
            vm.compMarkers = compPts.map(function (pts) {
                var p = vm.previewCurvePoint(pts, 0);
                return {left: p.x, top: p.y * 2.5};
            });

            scanTimers.push($timeout(function () { vm.trackerEndVisible = true; }, 850));

            /* La posizione media resta quella di prima: scende regolare fino a 1. */
            var labelCounter = $interval(function () {
                vm.trackerAvgPosition = Math.max(Math.round((vm.trackerAvgPosition - 0.5) * 10) / 10, 1);
                vm.trackerAvgIndex = Math.min(
                    Math.round((12 - vm.trackerAvgPosition) * 2),
                    vm.trackerPositionValues.length - 1
                );
                /* Le posizioni guadagnate salgono insieme al miglioramento. */
                vm.trackerGained = Math.round((12 - vm.trackerAvgPosition) / 11 * 6);
                if (vm.trackerAvgPosition <= 1) $interval.cancel(labelCounter);
            }, 80);
            scanTimers.push(labelCounter);

            var mentionsCounter = $interval(function () {
                vm.aiMentions = Math.min(vm.aiMentions + 52, AI_MENTIONS_TARGET);
                if (vm.aiMentions >= AI_MENTIONS_TARGET) $interval.cancel(mentionsCounter);
            }, 90);
            scanTimers.push(mentionsCounter);

            var started = Date.now();
            var duration = 2200;
            var reduced = typeof window !== 'undefined' && window.matchMedia &&
                window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var counter = $interval(function () {
                var t = Math.min((Date.now() - started) / duration, 1);
                if (reduced) t = 1;
                var eased = t * t * (3 - 2 * t);
                vm.trackerProgress = eased * 100;
                var yp = vm.previewCurvePoint(youPts, eased * (youPts.length - 1));
                vm.youMarker.left = yp.x;
                vm.youMarker.top = yp.y * 2.5;
                compPts.forEach(function (pts, i) {
                    /* Ogni curva usa il proprio span: le favicon dei competitor
                       altrimenti uscirebbero fuori scala con coordinate folli. */
                    var p = vm.previewCurvePoint(pts, eased * (pts.length - 1));
                    vm.compMarkers[i].left = p.x;
                    vm.compMarkers[i].top = p.y * 2.5;
                });
                if (t >= 1) $interval.cancel(counter);
            }, 33);
            scanTimers.push(counter);
        }

        /* Second story: the detected problems are fixed and the score rises. */
        function runFixStory() {
            vm.reportScore = 54;
            vm.reportIssues = 48;
            vm.reportPassed = 0;
            vm.previewAnomalies.slice(0, 4).forEach(function (item, index) {
                scanTimers.push($timeout(function () { item.state = 'is-fixed'; }, 250 + index * 480));
            });
            var started = Date.now();
            var duration = 2600;
            var counter = $interval(function () {
                var t = Math.min((Date.now() - started) / duration, 1);
                var eased = t * t * (3 - 2 * t);
                vm.reportScore = Math.round(54 + 38 * eased);
                vm.reportIssues = Math.round(48 * (1 - eased));
                vm.reportPassed = Math.round(33 * eased);
                if (t >= 1) $interval.cancel(counter);
            }, 40);
            scanTimers.push(counter);
        }

        function showEmptyScene(index) {
            if (destroyed || vm.projects.length) return;
            vm.emptyScene = sceneOrder[index % sceneOrder.length];
            cancelTimers(scanTimers);
            vm.previewAnomalies.forEach(function (item) { item.state = ''; });
            if (vm.emptyScene === 'issues') runScanStory();
            if (vm.emptyScene === 'fix') runFixStory();
            if (vm.emptyScene === 'tracker') runTrackerStory();
            var duration = {issues: 5600, fix: 3800, tracker: 3400, traffic: 4800}[vm.emptyScene] || 3400;
            sceneTimers.push($timeout(function () { showEmptyScene(index + 1); }, duration));
        }

        /* La storia parte solo quando lo stato vuoto è davvero in scena. */
        vm.$watch('projects.length', function (count) {
            if (destroyed) return;
            if (count) { stopEmptyStory(); return; }
            if (!sceneTimers.length) showEmptyScene(0);
        });
        vm.overview = {projects: 0, crawlErrors: 0, keywords: 0, pages: 0, completed: 0};
        vm.refreshOverview = getRankTrackerProject;
        vm.matchesProject = function (row) {
            var query = (vm.dashboardView.search || '').toLowerCase();
            return (!query || (row.name + ' ' + row.url).toLowerCase().indexOf(query) !== -1)
                && (vm.dashboardView.filter === 'all' || (vm.dashboardView.filter === 'attention' && row.needsAttention)
                    || (vm.dashboardView.filter === 'unscanned' && row.status === 'unscanned'));
        };
        vm.$on('$destroy', function () {
            destroyed = true;
            reportGeneration++;
            stopEmptyStory();
        });
        vm.$on('deleteProject', getRankTrackerProject);
        vm.$on('languageChanged', getRankTrackerProject);
        vm.$on('chart-create', function (event, chart) {
            if (!chart || !chart.chartArea || !chart.data || !chart.data.datasets) return;
            chart.data.datasets.forEach(function (dataset) {
                var color = dataset.borderColor === '#2f90de' ? '47, 144, 222' :
                    dataset.borderColor === '#a84ab2' ? '168, 74, 178' : '255, 138, 0';
                var gradient = chart.ctx.createLinearGradient(0, chart.chartArea.top, 0, chart.chartArea.bottom);
                gradient.addColorStop(0, 'rgba(' + color + ', .24)');
                gradient.addColorStop(1, 'rgba(' + color + ', 0)');
                dataset.backgroundColor = gradient;
            });
            chart.update(0);
        });

        function getRankTrackerProject() {
            if (!AuthService.isAuthenticated()) {
                vm.isLoading = false;
                return;
            }
            vm.isLoading = true;
            vm.projectLoadError = false;
            var generation = ++reportGeneration;
            SEOProjectsService.findAll()
                .then(function (projects) {
                    if (destroyed || generation !== reportGeneration) return;
                    if (!Array.isArray(projects)) throw new Error('Projects unavailable');
                    vm.projects = projects;
                    buildOverview(projects);
                    vm.projectsCreated = vm.projects.length;
                    vm.isLoading = false;
                    checkSearchConsole(generation);
                })
                .catch(function () {
                    if (destroyed || generation !== reportGeneration) return;
                    vm.projectLoadError = true;
                    vm.projects = [];
                    vm.projectsCreated = 0;
                    vm.isLoading = false;
                });
        }

        function buildOverview(projects) {
            vm.overview = {projects: projects.length, crawlErrors: 0, keywords: 0, pages: 0, completed: 0};
            vm.projectRows = projects.map(function (project) {
                var session = project.crawlerSession;
                var row = {
                    id: project.id, crawlerId: project.crawlerProject && project.crawlerProject.id,
                    name: project.name, url: (project.crawlerProject && project.crawlerProject.url) || (project.trackerProject && project.trackerProject.linkUrl) || '',
                    sessionId: session && session.id, date: session && session.createdAt,
                    score: session && session.status === 'finished' && typeof session.score === 'number' && isFinite(session.score) ? session.score : null,
                    pages: session ? Number(project.crawlerSessionPages || 0) : null,
                    crawlErrors: session ? Number(project.crawlerSessionErrors || 0) : null,
                    keywords: project.trackerProject && project.trackerProject.keywords ? project.trackerProject.keywords.length : 0,
                    trackerTop10: project.trackerProject && Array.isArray(project.trackerProject.keywords) ? project.trackerProject.keywords.filter(function (keyword) { var position = Number(keyword.position); return position >= 1 && position <= 10; }).length : null,
                    trackerLocations: project.trackerProject && Array.isArray(project.trackerProject.locations) ? project.trackerProject.locations.length : null,
                    trackerCompetitors: project.trackerProject && Array.isArray(project.trackerProject.competitors) ? project.trackerProject.competitors.length : null,
                    hasTracker: !!project.trackerProject,
                    searchConsoleConnected: false,
                    status: !session ? 'unscanned' : session.status === 'finished' ? 'ready' : (session.status === 'running' || session.status === 'deleting') ? 'running' : 'failed'
                };
                row.faviconUrl = row.url ? FavIconService.get(row.url) : null;
                row.needsAttention = row.status === 'unscanned' || row.status === 'failed' || row.crawlErrors > 0;
                vm.overview.pages += row.pages || 0;
                vm.overview.crawlErrors += row.crawlErrors || 0;
                vm.overview.keywords += row.keywords;
                if (row.status === 'ready') vm.overview.completed++;
                return row;
            });
        }
        function checkSearchConsole(generation) {
            var connectionGeneration = ++searchConsoleGeneration;
            lastCheckedSearchConsoleConnection = $window.localStorage.getItem('searchConsoleProjectConnection');
            vm.searchConsoleMissingCount = vm.projectRows.length;
            vm.searchConsoleChecking = !!vm.projectRows.length;
            vm.projectRows.forEach(function (row) {
                row.searchConsoleConnected = false;
                row.searchConsoleProperty = null;
                row.searchConsoleMetrics = null;
                row.searchConsoleMetricsLoading = false;
                row.searchConsoleMetricsError = false;
                row.searchConsoleCharts = null;
            });
            if (!vm.searchConsoleChecking) return;

            var projectIds = vm.projectRows.map(function (row) { return row.id; });
            SearchConsoleService.getProjectConnections(projectIds).then(function (connections) {
                if (destroyed || generation !== reportGeneration || connectionGeneration !== searchConsoleGeneration) return;
                var byProject = {};
                (connections || []).forEach(function (connection) {
                    byProject[connection.projectId] = connection;
                });
                vm.projectRows.forEach(function (row) {
                    var connection = byProject[row.id];
                    row.searchConsoleProperty = connection && connection.connected ? connection.propertyUrl : null;
                    row.searchConsoleConnected = !!row.searchConsoleProperty;
                });
                vm.searchConsoleMissingCount = vm.projectRows.filter(function (row) { return !row.searchConsoleConnected; }).length;
                vm.searchConsoleChecking = false;
                loadSearchConsoleMetrics(generation, connectionGeneration);
            }).catch(function () {
                if (destroyed || generation !== reportGeneration || connectionGeneration !== searchConsoleGeneration) return;
                vm.searchConsoleChecking = false;
            });
        }

        function loadSearchConsoleMetrics(generation, connectionGeneration) {
            var rows = vm.projectRows.filter(function (row) { return row.searchConsoleConnected; });
            var rowsByProject = {};
            rows.forEach(function (row) {
                row.searchConsoleMetricsLoading = true;
                rowsByProject[row.id] = row;
            });
            var projectIds = Object.keys(rowsByProject);
            var nextIndex = 0;
            function loadNext() {
                if (destroyed || generation !== reportGeneration || connectionGeneration !== searchConsoleGeneration || nextIndex >= projectIds.length) return;
                var projectId = projectIds[nextIndex++];
                var row = rowsByProject[projectId];
                SearchConsoleService.getProjectSummary(projectId)
                    .then(function (response) {
                        if (destroyed || generation !== reportGeneration || connectionGeneration !== searchConsoleGeneration) return;
                        row.searchConsoleMetrics = response || null;
                        row.searchConsoleCharts = buildSearchConsoleCharts(row.searchConsoleMetrics);
                    })
                    .catch(function () {
                        if (destroyed || generation !== reportGeneration || connectionGeneration !== searchConsoleGeneration) return;
                        row.searchConsoleMetricsError = true;
                    })
                    .finally(function () {
                        if (destroyed || generation !== reportGeneration || connectionGeneration !== searchConsoleGeneration) return;
                        row.searchConsoleMetricsLoading = false;
                        loadNext();
                    });
            }
            loadNext();
            loadNext();
        }

        function buildSearchConsoleCharts(summary) {
            if (!summary || !Array.isArray(summary.series) || !summary.series.some(function (day) { return day.clicks !== null; })) return null;
            var labels = summary.series.map(function (day) { return day.date.slice(8, 10) + '/' + day.date.slice(5, 7); });
            var xAxis = [{display: false}];
            var yTicks = {display: false};
            var baseOptions = {responsive: true, maintainAspectRatio: false, legend: {display: false},
                tooltips: {mode: 'index', intersect: false}, hover: {mode: 'nearest', intersect: false}};
            return {
                clicks: {
                    labels: labels,
                    data: [summary.series.map(function (day) { return day.clicks; })],
                    series: [$translate.instant('dashboard.overview.gscClicks')],
                    datasets: [{borderColor: '#ff8a00', backgroundColor: 'rgba(255, 138, 0, .16)', pointRadius: 0, pointHoverRadius: 0, borderWidth: 2, fill: 'start', lineTension: .18, spanGaps: false}],
                    options: Object.assign({}, baseOptions, {scales: {xAxes: xAxis, yAxes: [
                        {type: 'linear', display: false, ticks: Object.assign({beginAtZero: true}, yTicks)}
                    ]}})
                },
                impressions: {
                    labels: labels,
                    data: [summary.series.map(function (day) { return day.impressions; })],
                    series: [$translate.instant('dashboard.overview.gscImpressions')],
                    datasets: [{borderColor: '#2f90de', backgroundColor: 'rgba(47, 144, 222, .16)', pointRadius: 0, pointHoverRadius: 0, borderWidth: 2, fill: 'start', lineTension: .18, spanGaps: false}],
                    options: Object.assign({}, baseOptions, {scales: {xAxes: xAxis, yAxes: [
                        {type: 'linear', display: false, ticks: Object.assign({beginAtZero: true}, yTicks)}
                    ]}})
                },
                position: {
                    labels: labels,
                    data: [summary.series.map(function (day) { return day.position; })],
                    series: [$translate.instant('dashboard.overview.gscPosition')],
                    datasets: [{borderColor: '#a84ab2', backgroundColor: 'rgba(168, 74, 178, .14)', pointRadius: 0, pointHoverRadius: 0, borderWidth: 2, fill: 'start', lineTension: .18, spanGaps: false}],
                    options: Object.assign({}, baseOptions, {scales: {xAxes: xAxis, yAxes: [
                        {type: 'linear', display: false, position: 'left', ticks: Object.assign({reverse: true}, yTicks)}
                    ]}})
                }
            };
        }

        function connectSearchConsole(row) {
            vm.searchConsoleConnectError = false;
            SearchConsoleService.connectProject({id: row.id, workspaceId: vm.workspace.id, name: row.name, url: row.url})
                .catch(function () { vm.searchConsoleConnectError = true; });
        }

        function deleteProject(project, event) {
            if (!project || !project.id) {
                return;
            }
            var dialogProject = angular.copy(project);
            dialogProject.projectId = project.id;
            $mdDialog.show({
                controller: 'ProjectDeleteProjectCtrl',
                templateUrl: 'app/modules/project/dialogs/delete-project/delete-project.html',
                targetEvent: event,
                clickOutsideToClose: true,
                parent: angular.element(document.body),
                locals: {
                    project: dialogProject
                }
            }).then(function () {
                removeProjectFromScope(project.id);
            }, angular.noop);
        }

        function removeProjectFromScope(projectId) {
            var normalizedId = String(projectId);
            vm.projects = vm.projects.filter(function (project) {
                return String(project.id) !== normalizedId;
            });
            vm.projectRows = vm.projectRows.filter(function (row) {
                return String(row.id) !== normalizedId;
            });
            vm.projectsCreated = vm.projects.length;
            recalculateOverview();
        }

        function recalculateOverview() {
            var overview = {projects: vm.projectRows.length, crawlErrors: 0, keywords: 0, pages: 0, completed: 0};
            vm.projectRows.forEach(function (row) {
                overview.pages += row.pages || 0;
                overview.crawlErrors += row.crawlErrors || 0;
                overview.keywords += row.keywords || 0;
                if (row.status === 'ready') overview.completed++;
            });
            vm.overview = overview;
            vm.searchConsoleMissingCount = vm.projectRows.filter(function (row) {
                return !row.searchConsoleConnected;
            }).length;
            if (!vm.projectRows.length) {
                searchConsoleGeneration++;
                vm.searchConsoleChecking = false;
            }
        }

        function refreshSearchConsole() {
            if (destroyed || vm.isLoading || !vm.projectRows.length ||
                $window.localStorage.getItem('searchConsoleProjectConnection') === lastCheckedSearchConsoleConnection) return;
            $scope.$applyAsync(function () { checkSearchConsole(reportGeneration); });
        }

        $window.addEventListener('focus', refreshSearchConsole);
        $window.addEventListener('storage', refreshSearchConsole);
        vm.$on('$destroy', function () {
            $window.removeEventListener('focus', refreshSearchConsole);
            $window.removeEventListener('storage', refreshSearchConsole);
        });

        getRankTrackerProject();
    }
    Controller.$inject = ['$scope', '$state', 'userInfo', 'ProjectsService', 'AuthService', 'TrackEventService', '$localStorage', 'FavIconService', 'SearchConsoleService', '$window', '$translate', '$interval', '$timeout', '$mdDialog'];
    return Controller;
});
